import React from "react";
import {Button, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(() => ({
    orangeBtn: (props: any) => ({
        '&.MuiButton-root': {
            padding: `8px 12px`,
            height: `36px`,
            background: props.backgroundColor,
            color: `#FFFFFF`,
            borderRadius: `2px`,
            border: `none`,
            fontSize: `14px`,
            lineHeight: `1`,
            display: `flex`,
            alignItems: `center`,
            textTransform: `capitalize`,
            width: props.width,
            '&:hover': {
                opacity: `0.7`,
                backgroundColor: props.backgroundColor,
            },
            '&:disabled': {
                opacity: `0.5`,
                color: `#FFFFFF`,
            }
        }
    })
}))

type Props = {
    buttonName: string;
    backgroundColor?: string;
    isDisabled?: boolean;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    width?: number;
}


export const OrangeButton = (props: Props) => {
    const properties = {
        backgroundColor: props.backgroundColor || `linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)`,
        width: `${props.width}%` || "auto"
    }
    const classes = useStyles(properties);
    return (
        <Button className={classes.orangeBtn} type="submit" disabled={props.isDisabled} onClick={props.onClick}>
            <Typography>
                {props.buttonName}
            </Typography>
        </Button>
    )
}